import apiClient from "../../apiClient";
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// get tile list
export const getFSTileList = async (fs_feature_id: number) => {
  try {
    const response = await apiClient.get(`/api/fs-tile-list/${fs_feature_id}`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    console.error("Error fetching data:", error);

    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// create tile location
export const fsTileLocationCreate = async (
  fs_feature_id: number,
  location_name: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/fs-tile-location/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ fs_feature_id, location_name }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update tile location
export const fsTileLocationUpdate = async (
  id: number,
  fs_feature_id: number,
  location_name: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/fs-tile-location/update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ id, fs_feature_id, location_name }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// delete tile location
export const fsTileLocationDelete = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/fs-tile-location/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// create Tiles
export const fsTilesCreate = async (
  fs_data_id: number,
  shop_id: number,
  color_id: number,
  type_id: number,
  name: string,
  quantity: number,
  size: number,
  link: string | null,
  image_path: File | null,
  file_list: File[] | null
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const formData = new FormData();
    formData.append("fs_data_id", String(fs_data_id));
    formData.append("shop_id", String(shop_id));
    formData.append("type_id", String(type_id));
    formData.append("color_id", String(color_id));
    formData.append("name", name);
    formData.append("quantity", String(quantity));
    formData.append("size", String(size));


    if (link !== null) {
      formData.append("link", link);
    }

    if (image_path !== null) {
      formData.append("image_path", image_path);
    }

    if (file_list !== null) {
      file_list.forEach((file, index) => {
        formData.append("file_list[]", file);
      });
    }

    const response = await fetch(`${baseURL}/api/fs-tile/create`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update Tiles
export const fsTilesUpdate = async (
  id: number,
  shop_id: number,
  color_id: number,
  type_id: number,
  name: string,
  quantity: number,
  size: number,
  link: string | null,
  image_path: File | null,
  file_list: File[] | null
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const formData = new FormData();

    formData.append("shop_id", String(shop_id));
    formData.append("type_id", String(type_id));
    formData.append("color_id", String(color_id));
    formData.append("name", name);
    formData.append("quantity", String(quantity));
    formData.append("size", String(size));

    if (link !== null) {
      formData.append("link", link);
    }

    if (image_path !== null) {
      formData.append("image_path", image_path);
    }

    if (file_list !== null) {
      file_list.forEach((file, index) => {
        formData.append("file_list[]", file);
      });
    }

    const response = await fetch(`${baseURL}/api/fs-tile/update/${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete Tiles
export const fsTilesDelete = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/fs-tile/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete  single file
export const fsTilesFileDelete = async (
  Tiles_accessory_data_id: number,
  index: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/fs-tile-file/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ Tiles_accessory_data_id, index }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};